import { Grid, Toggle } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import { useCardSkeletonColumns } from '../useSingleOrDoubleColumns'
import OtherInformationSkeleton from './OtherInformationSkeleton'
import useSourceCentricDetailsFlag from '../../../data-service/useSourceCentricDetailsFlag'

type Props = {
  isSingleCardPage?: boolean
  totalColumns?: number
}

export default function OtherInformationCardSkeleton({
  isSingleCardPage = true,
  totalColumns = 12,
}: Props): JSX.Element {
  const [t] = useTranslation()
  const columns = useCardSkeletonColumns(totalColumns)
  const isSourceCentric = useSourceCentricDetailsFlag().data?.isOn

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton
        isSingleCardPage={isSingleCardPage}
        heading={t('tree-person.other-information.label')}
        headerEndElement={
          isSourceCentric && (
            <Toggle
              aria-label={t('tree-person.show-contributor-details.label')}
              data-testid="facts-detail-view"
              label={t('tree-person.detail-view.label')}
              disabled
            />
          )
        }
      >
        <OtherInformationSkeleton columns={columns} />
      </SectionCardSkeleton>
    </Grid>
  )
}
